<div class="headers-details" [ngClass]="screenClasses()">
  <div class="info">
    <div class="name">{{ title | customLocale }}</div>
  </div>
</div>
